// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function FactoryBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M15 22a1.5 1.5 0 0 1-1.5 1.5H10a1.5 1.5 0 1 1 0-3h3.5A1.5 1.5 0 0 1 15 22Zm7-1.5h-3.5a1.5 1.5 0 1 0 0 3H22a1.5 1.5 0 1 0 0-3Zm9.5 6.5a1.5 1.5 0 0 1-1.5 1.5H2a1.5 1.5 0 1 1 0-3h1.5V11a1.5 1.5 0 0 1 2.4-1.2l5.6 4.2v-3a1.5 1.5 0 0 1 2.4-1.2l4.166 3.125 1.326-9.279A2.512 2.512 0 0 1 21.868 1.5h2.265a2.512 2.512 0 0 1 2.475 2.146l1.875 13.142c0 .012.014.167.014.212v8.5h1.5A1.5 1.5 0 0 1 31.5 27ZM20.804 14.979l.696.521h3.77l-1.571-11H22.3l-1.497 10.479ZM6.5 25.5h19v-7H21a1.5 1.5 0 0 1-.9-.3l-1.798-1.348h-.007L14.5 14v3a1.5 1.5 0 0 1-2.4 1.2L6.5 14v11.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
